// DESCRIPTION: Step 5 of the event creation wizard — banner image plus the
// DESCRIPTION: per-event visual styling editor, with a live preview sidecar.
import EventStylingEditor from '../EventStylingEditor';
import BannerUploader from './BannerUploader';

const StylingStep = ( { formData, onFieldChange } ) => {
	return (
		<div className="nemtly-wizard-step-content">
			<BannerUploader
				value={ formData.featured_image || '' }
				onChange={ ( url ) => onFieldChange( 'featured_image', url ) }
			/>

			<EventStylingEditor
				formData={ formData }
				styling={ formData.styling || {} }
				onChange={ ( styling ) => onFieldChange( 'styling', styling ) }
				templates={ window.nemtlyCreateEvent?.templates || {} }
			/>
		</div>
	);
};

export default StylingStep;
